module.exports = _.isEmpty;


//////////////////
// WEBPACK FOOTER
// external "_.isEmpty"
// module id = 138
// module chunks = business-manager/shoutout-popup business-manager/video-library-page shoutout/shoutout full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings